import { Box } from "@chakra-ui/react";
import { BiChevronsDown, BiChevronsUp } from "react-icons/bi";
import { MdRadioButtonChecked } from "react-icons/md";

type BulletIconProps = {
  isFilled: boolean;
  isOpen: boolean;
  isIndicator: boolean;
};

export default function BulletIcon({ isFilled, isOpen, isIndicator }: BulletIconProps) {


  if (isOpen)
    return isFilled ? <Box as={isIndicator ? MdRadioButtonChecked: BiChevronsUp } color={isFilled && isIndicator ?"green.500":"gray.500"} className={"tree-bullet"} size={"2em"} /> : <Box as={isIndicator ? MdRadioButtonChecked: BiChevronsUp} color={"gray.500"} className={"tree-bullet"} size={"2em"} />;
  else
    return isFilled ? <Box as={isIndicator ? MdRadioButtonChecked: BiChevronsDown} color={isFilled && isIndicator ?"green.500":"gray.500"}  className={"tree-bullet"} size={"2em"} /> : <Box as={isIndicator ? MdRadioButtonChecked: BiChevronsDown} color={"gray.500"} className={"tree-bullet"} size={"2em"} />;
}
